export const FIRM_DOCUMENT_FILE_ACTIONS_TEST_IDS = {
  copyAction: (documentReferenceId: number) => `firm-documents-file-copy-action-${documentReferenceId}`,
  deleteAction: (documentReferenceId: number) => `firm-documents-file-delete-action-${documentReferenceId}`,
  downloadAction: (documentReferenceId: number) => `firm-documents-file-download-action-${documentReferenceId}`,
  root: (documentReferenceId: number) => `firm-documents-file-actions-${documentReferenceId}`,
  renameAction: (documentReferenceId: number) => `firm-documents-file-rename-action-${documentReferenceId}`,
} as const;
